import { de, fr, enGB, es } from 'date-fns/locale';

export enum Language {
  'en' = 'en',
  'de' = 'de',
  'fr' = 'fr',
  'es' = 'es',
}
export type Namespace = 'translation';

export const dateLocales: {
  [key in Language | 'default']: typeof enGB;
} = {
  en: enGB,
  de: de,
  fr: fr,
  es: es,
  default: enGB,
};

export const fallbackLng: Language = Language.en;
export const defaultNS: Namespace = 'translation';

export const languages: Language[] = Object.values(Language);
export const namespaces = [defaultNS];
